import Vue from "vue";
import VueRouter from "vue-router";
import LaunchPage from "../ui/launch.vue";
import LoginPage from "../ui/login.vue";
import Main from "../ui/main.vue";
import Home from "../ui/home.vue";
import { announcementListRoute } from './announcement.js';
import { todoListRoute } from './todo.js';
import { workLogListRoute } from './work-log.js';
import { projectListRoute, projectEditorRoute, projectCreatorRoute } from './project.js';
import { workOrderListRoute } from './work-order.js';
import { leaveFormListRoute } from './leave-form.js';
import { compensatoryTimeListRoute } from './compensatory-time.js';
// me
import { rewardRoute } from './me/reward.js';
import { profileRoute } from './me/profile.js';
// management
import { employeeListRoute } from './management/user.js';
import { clientListRoute } from './management/client.js';
import { departmentListRoute } from './management/department.js';
import { countyListRoute } from './management/county.js';
// accounting
import { salaryRoute } from './accounting/salary.js';

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "launch",
    component: LaunchPage
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage
  },
  {
    path: "/main",
    component: Main,
    name: "main",
    children: [
      // {
      //   path: "/main",
      //   name: "home",
      //   component: Home
      // },
      announcementListRoute,
      todoListRoute,
      workLogListRoute,
      workOrderListRoute,
      leaveFormListRoute,
      // project
      projectListRoute,
      projectCreatorRoute,
      projectEditorRoute,
      // me
      profileRoute,
      rewardRoute,
      // management
      employeeListRoute,
      clientListRoute,
      departmentListRoute,
      countyListRoute,
      compensatoryTimeListRoute,
      // accounting
      salaryRoute,
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
